import { render, staticRenderFns } from "./ClubDashboard.vue?vue&type=template&id=119456ea"
import script from "./ClubDashboard.vue?vue&type=script&lang=js"
export * from "./ClubDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports